const data=
    {
      Response: [
        {
          ImpuestosDesgloseGeneral: {
            ImpuestoRepercutido: 0,
            BaseRepercutido: 0,
            ImpuestoSoportado: 0,
            BaseSoportado: 0,
            Total: 0
          },
          ImpuestoDesgloseDashboardPorcentaje: [
            {
              Porcentaje: 0,
              Tipo: 0,
              ImpuestoRepercutido: 0,
              BaseRepercutido: 0,
              ImpuestoSoportado: 0,
              BaseSoportado: 0,
              Total: 0
            }
          ],
          Fecha: 'string'
        }
      ],
      blnError: false,
      codError: 'string',
      msgError: 'string'
    }
export default data
